import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { BarChart } from '@mui/x-charts/BarChart';


export class BarChartGroupedCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      context: this.props.context ? this.props.context : 'paciente',
      dataini: this.props.dataini ? this.props.dataini : new Date().toISOString().substring(0, 10),
      datafim: this.props.datafim ? this.props.datafim : new Date().toISOString().substring(0, 10),
      sexo: this.props.sexo ? this.props.sexo : [1],
      idade: this.props.idade ? this.props.idade : [18,100],
      procedimento: this.props.procedimento ? this.props.procedimento : [1],
      doutor: this.props.doutor ? this.props.doutor : [1],
      title: '---',
      description: '---',
      dataLabel: [],
      series: [],
    };
  }
  
  
  componentDidMount = () => {
    this.updateData();
  }; 
  
  
  
  updateStates = (dataini, datafim, sexo, idade, procedimento, doutor) => {
    this.setState({ dataini: dataini, datafim: datafim, sexo: sexo, idade: idade, procedimento: procedimento, doutor: doutor }, () => {this.updateData()} );
  }
  
  
  
  
  updateData = () => {
    if(this.state.context === 'equipe'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/TeamChart/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Equipe',
            description: "Procedimento,Profissional x Número de Sessões",
            dataLabel: retValues[0],
            series: retValues[1],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }    
    
    
  
    if(this.state.context === 'genero'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/GenderChart/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Gênero',
            description: "Procedimento,Gênero x Número de Sessões",
            dataLabel: retValues[0],
            series: retValues[1],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }  
    
      
  }; 
  
  
  
  parseStats(r){
    //console.log(r.data);
    
    var dataLabel = [];
    var series = [];
    
    //Get arrays with the values of treatment name, initialized array with the same number of elements of treatment name array, and finally, theme names
    var series_data = [];
    var series_label = [];
    
    for(let [trat_key, trat_value] of Object.entries(r.data)) {
      dataLabel.push(trat_key);
      series_data.push(0);
      for(let [theme,] of Object.entries(trat_value)){
        if(series_label.indexOf(theme) === -1)
          series_label.push(theme)
      }
    }
    
    //Initialize series
    for(var l in series_label)
      series.push({"label": series_label[l], "data": structuredClone(series_data)});
    
    //Put counts into the correct position  
    var indexPosition;  
    for(let [trat_key, trat_value] of Object.entries(r.data)) {
      indexPosition = dataLabel.indexOf(trat_key);
      if(indexPosition !== -1){
        for(let [theme,count] of Object.entries(trat_value)){
          //Find out where is theme in series list
          for(const s of series){
            if(s.label === theme){
              s.data[indexPosition] = count;
              break;
            }
          }          
        }
      }
    }
                
    return([dataLabel, series]);
  }
  
  

    
  
  
  
  render() {
    const colorPalette = ['#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff'];
  
    return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>{this.state.title}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>{this.state.description}</Typography>

        {this.state.series.length>0 &&
        <BarChart
          borderRadius={8}
          colors={colorPalette}
          xAxis={[
            {
              scaleType: 'band',
              categoryGapRatio: 0.5,
              data: this.state.dataLabel,
            },
          ]}
          series={this.state.series}
          height={250}
          margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
        /> 
        }
      </CardContent>
    </Card>
    
    
    );
  }
}























